import { render, staticRenderFns } from "./IotModelEventReportForm.vue?vue&type=template&id=7504ec5c&"
import script from "./IotModelEventReportForm.vue?vue&type=script&lang=js&"
export * from "./IotModelEventReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports